// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___3dQlO","container":"container___2nGsE","size":"size___3GZyc","header":"header___3yA84"};